import React from "react";
import Card from "react-bootstrap/Card";

export const Terms = () => {
    return (
        <>
            <div className="container-fluid mt-4">
                <Card className="mb-4 w-100">
                    <Card.Header as="h2" className="header-card">
                        <span>
                            AGREEMENT BETWEEN USER AND Navajo Nation Department
                            of Personnel Management
                        </span>
                    </Card.Header>
                    <Card.Body>
                        <div className="card-text">
                            The Navajo Nation Department of Personnel Management
                            Web Site is comprised of various Web pages operated
                            by Navajo Nation Department of Personnel Management.
                            The Navajo Nation Department of Personnel Management
                            Web Site is offered to you conditioned on your
                            acceptance without modification of the terms,
                            conditions, and notices contained herein. Your use
                            of the Navajo Nation Department of Personnel
                            Management Web Site constitutes your agreement to
                            all such terms, conditions, and notices.
                        </div>
                    </Card.Body>
                </Card>
                <Card className="mb-4">
                    <Card.Header as="h2" className="header-card">
                        <span>MODIFICATION OF THESE TERMS OF USE</span>
                    </Card.Header>
                    <Card.Body>
                        <div className="card-text">
                            Navajo Nation Department of Personnel Management
                            reserves the right to change the terms, conditions,
                            and notices under which the Navajo Nation Department
                            of Personnel Management Web Site is offered,
                            including but not limited to the charges associated
                            with the use of the Navajo Nation Department of
                            Personnel Management Web Site.
                        </div>
                    </Card.Body>
                </Card>
                <Card className="mb-4">
                    <Card.Header as="h2" className="header-card">
                        <span>LINKS TO THIRD PARTY SITES</span>
                    </Card.Header>
                    <Card.Body>
                        <div className="card-text">
                            The Navajo Nation Department of Personnel Management
                            Web Site may contain links to other Web Sites
                            (&quot;Linked Sites&quot;). The Linked Sites are not
                            under the control of Navajo Nation Department of
                            Personnel Management and Navajo Nation Department of
                            Personnel Management is not responsible for the
                            contents of any Linked Site, including without
                            limitation any link contained in a Linked Site, or
                            any changes or updates to a Linked Site. Navajo
                            Nation Department of Personnel Management is not
                            responsible for webcasting or any other form of
                            transmission received from any Linked Site. Navajo
                            Nation Department of Personnel Management is
                            providing these links to you only as a convenience,
                            and the inclusion of any link does not imply
                            endorsement of the site by Navajo Nation Department
                            of Personnel Management or any association with its
                            operators.
                        </div>{" "}
                    </Card.Body>
                </Card>
                <Card className="mb-4">
                    <Card.Header as="h2" className="header-card">
                        <span>NO UNLAWFUL OR PROHIBITED USE</span>
                    </Card.Header>
                    <Card.Body>
                        <div className="card-text">
                            As a condition of your use of the Navajo Nation
                            Department of Personnel Management Web Site, you
                            warrant to Navajo Nation Department of Personnel
                            Management that you will not use the Navajo Nation
                            Department of Personnel Management Web Site for any
                            purpose that is unlawful or prohibited by these
                            terms, conditions, and notices. You may not use the
                            Navajo Nation Department of Personnel Management Web
                            Site in any manner which could damage, disable,
                            overburden, or impair the Navajo Nation Department
                            of Personnel Management Web Site or interfere with
                            any other party&apos;s use and enjoyment of the
                            Navajo Nation Department of Personnel Management Web
                            Site. You may not obtain or attempt to obtain any
                            materials or information through any means not
                            intentionally made available for your use by the
                            Navajo Nation Department of Personnel Management Web
                            Sites.
                        </div>
                    </Card.Body>
                </Card>
                <Card className="mb-4">
                    <Card.Header as="h2" className="header-card">
                        <span>USE OF COMMUNICATION SERVICES</span>
                    </Card.Header>
                    <Card.Body>
                        <div className="card-text">
                            The Navajo Nation Department of Personnel Management
                            Web Site may contain bulletin board services, chat
                            areas, news groups, forums, communities, personal
                            web pages, calendars, and/or other message or
                            communication facilities designed to enable you to
                            communicate with the public at large or with a group
                            (collectively, &quot;Communication Services&quot;.
                            You agree to use the Communication Services only to
                            post, send, and receive messages and material that
                            are proper and related to the particular
                            Communication Service. By way of example, and not as
                            a limitation, you agree that when using a
                            Communication Service, you will not:
                            <ul>
                                <li>
                                    Defame, abuse, harass, stalk, threaten, or
                                    otherwise violate the legal rights (such as
                                    rights of privacy or publicity) of others.
                                </li>
                                <li>
                                    Publish, post, upload, distribute, or
                                    disseminate any inappropriate, profane,
                                    defamatory, infringing, obscene, indecent,
                                    or unlawful topic, name, material, or
                                    information.
                                </li>
                                <li>
                                    Upload files that contain software or other
                                    material protected by intellectual property
                                    laws (or by rights of privacy of publicity),
                                    unless you own or control the rights thereto
                                    or have received all necessary consents.
                                </li>
                                <li>
                                    Upload files that contain viruses, corrupted
                                    files, or any other similar software or
                                    programs that may damage the operation of
                                    another&apos;s computer.
                                </li>
                                <li>
                                    Conduct or forward surveys, contests,
                                    pyramid schemes, or chain letters.
                                </li>
                                <li>
                                    Download any file posted by another user of
                                    a Communication Service that you know, or
                                    reasonably should know, cannot be legally
                                    distributed in such manner.
                                </li>
                                <li>
                                    Falsify or delete any author attributions,
                                    legal or other proper notices, or
                                    proprietary designations or labels of the
                                    origin or source of software or other
                                    material contained in a file that is
                                    uploaded.
                                </li>
                                <li>
                                    Restrict or inhibit any other user from
                                    using and enjoying the Communication
                                    Services.
                                </li>
                                <li>
                                    Violate any code of conduct or other
                                    guidelines which may be applicable for any
                                    particular Communication Service.
                                </li>
                                <li>
                                    Harvest or otherwise collect information
                                    about others, including e-mail addresses,
                                    without their consent.
                                </li>
                                <li>
                                    Violate any applicable laws or regulations.
                                </li>
                            </ul>
                            Navajo Nation Department of Personnel Management has
                            no obligation to monitor the Communication Services.
                            However, Navajo Nation Department of Personnel
                            Management reserves the right to review materials
                            posted to a Communication Service and to remove any
                            materials in its sole discretion. Navajo Nation
                            Department of Personnel Management reserves the
                            right to terminate your access to any or all of the
                            Communication Services at any time without notice
                            for any reason whatsoever. Navajo Nation Department
                            of Personnel Management reserves the right at all
                            times to disclose any information as necessary to
                            satisfy any applicable law, regulation, legal
                            process, or governmental request, or to edit, refuse
                            to post, or remove any information or materials, in
                            whole or in part, in Navajo Nation Department of
                            Personnel Management&apos;s sole discretion. Always
                            use caution when giving out any personally
                            identifying information about yourself or your
                            children in any Communication Service. Navajo Nation
                            Department of Personnel Management does not control
                            or endorse the content, messages or information
                            found in any Communication Service and, therefore,
                            Navajo Nation Department of Personnel Management
                            specifically disclaims any liability with regard to
                            the Communication Services and any actions resulting
                            from your participation in any Communication
                            Service. Managers and hosts are not authorized
                            Navajo Nation Department of Personnel Management
                            spokespersons, and their views do not necessarily
                            reflect those of Navajo Nation Department of
                            Personnel Management. Materials uploaded to a
                            Communication Service may be subject to posted
                            limitations on usage, reproduction and/or
                            dissemination. You are responsible for adhering to
                            such limitations if you download the materials.
                            MATERIALS PROVIDED TO Navajo Nation Department of
                            Personnel Management OR POSTED TO ANY Navajo Nation
                            Department of Personnel Management WEB SITE Navajo
                            Nation Department of Personnel Management does not
                            claim ownership of the materials you provide to
                            Navajo Nation Department of Personnel Management
                            (including feedback and suggestions) or post,
                            upload, input, or submit to any Navajo Nation
                            Department of Personnel Management Web Site or its
                            associated services (collectively
                            &quot;submissions&quot;). However, by posting,
                            uploading, inputting, providing, or submitting your
                            Submission, you are granting Navajo Nation
                            Department of Personnel Management, its affiliated
                            companies, and necessary sublicensees permission to
                            use your Submission in connection with the operation
                            of their Internet operations/businesses including,
                            without limitation, the rights to: copy, distribute,
                            transmit, publicly display, publicly perform,
                            reproduce, edit, translate, or reformat your
                            Submission; and to publish your name in connection
                            with your Submission. No compensation will be paid
                            with respect to the use of your Submission, as
                            provided herein. Navajo Nation Department of
                            Personnel Management is under no obligation to post
                            or use any Submission you may provide and may remove
                            any Submission at any time in Navajo Nation
                            Department of Personnel Management&apos;s sole
                            discretion. By posting, uploading, inputting,
                            providing, or submitting your Submission, you
                            warrant and represent that you own or otherwise
                            control all of the rights to your Submission as
                            described in this section including, without
                            limitation, all the rights necessary for you to
                            provide, post, upload, input, or submit the
                            Submissions.
                        </div>
                    </Card.Body>
                </Card>
                <Card className="mb-4">
                    <Card.Header as="h2" className="header-card">
                        <span>LIABILITY DISCLAIMER</span>
                    </Card.Header>
                    <Card.Body>
                        <div className="card-text">
                            The information, software, products, and services
                            included in or available through the Navajo Nation
                            Department of Personnel Management web site may
                            include inaccuracies or typographical errors.
                            Changes are periodically added to the information
                            herein. Navajo Nation Department of Personnel
                            Management and/or its vendors may make improvements
                            and/or changes to the Navajo Nation Department of
                            Personnel Management web site at any time. Advice
                            received via the Navajo Nation Department of
                            Personnel Management web site should not be relied
                            upon for personal, medical, legal, or financial
                            decisions, and you should consult an appropriate
                            professional for specific advice tailored to your
                            situation. Navajo Nation Department of Personnel
                            Management and/or its suppliers make no
                            representations about the suitability, reliability,
                            availability, timeliness, or accuracy of the
                            information, software, products, services and
                            related graphics contained on the Navajo Nation
                            Department of Personnel Management web site for any
                            purpose. To the maximum extent permitted by
                            applicable law, all such information, software,
                            products, services, and related graphics are
                            provided &quot;as is&quot; without warranty or
                            condition of any kind. Navajo Nation Department of
                            Personnel Management and/or its suppliers hereby
                            disclaim all warranties and conditions with regard
                            to this information, software, products, services,
                            and related graphics, including all implied
                            warranties or conditions of merchantability, fitness
                            for a particular purpose, title, and
                            non-infringement. To the maximum extent permitted by
                            applicable law, in no event shall Navajo Nation
                            Department of Personnel Management and/or its
                            vendors be liable for any direct, indirect,
                            punitive, incidental, special, or consequential
                            damages, or any damages whatsoever, including
                            damages for loss of use, data, or profits arising
                            out of or in any way connected with the use or
                            performance of the Navajo Nation Department of
                            Personnel Management web site. Nor shall Navajo
                            Nation Department of Personnel Management and/or its
                            vendors be liable for any delay in using, or
                            inability to use, the Navajo Nation Department of
                            Personnel Management web site or related services,
                            the provision of or failure to provide services, or
                            for any information, software, products, services,
                            or related graphics obtained or used through the
                            Navajo Nation Department of Personnel Management web
                            site, or otherwise arising out of the use of the
                            Navajo Nation Department of Personnel Management web
                            site, whether based on contract, tort, negligence,
                            strict liability or otherwise, even if Navajo Nation
                            Department of Personnel Management or any of its
                            suppliers has been advised of the possibility of
                            damages. If you are dissatisfied with any portion of
                            the Navajo Nation Department of Personnel Management
                            web site, or with any of these terms of use, your
                            sole and exclusive remedy is to discontinue using
                            the Navajo Nation Department of Personnel Management
                            web site. Service contact:
                            traci.shortey@dpm.navajo-nsn.gov
                        </div>
                    </Card.Body>
                </Card>
                <Card className="mb-4">
                    <Card.Header as="h2" className="header-card">
                        <span>TERMINATION/ACCESS RESTRICTION</span>
                    </Card.Header>
                    <Card.Body>
                        <div className="card-text">
                            Navajo Nation Department of Personnel Management
                            reserves the right, in its sole discretion, to
                            terminate your access to the Navajo Nation
                            Department of Personnel Management Web Site and the
                            related services, or any portion thereof, at any
                            time, without notice.
                        </div>
                    </Card.Body>
                </Card>
                <Card className="mb-4">
                    <Card.Header as="h2" className="header-card">
                        <span>GENERAL</span>
                    </Card.Header>
                    <Card.Body>
                        <div className="card-text">
                            To the maximum extent permitted by law, this
                            agreement is governed by the laws of the Navajo
                            Nation, and you hereby consent to the exclusive
                            jurisdiction and venue of courts of the Navajo
                            Nation in all disputes arising out of or relating to
                            the use of the Navajo Nation Department of Personnel
                            Management Web Site. Use of the Navajo Nation
                            Department of Personnel Management Web Site is
                            unauthorized in any jurisdiction that does not give
                            effect to all provisions of these terms and
                            conditions, including without limitation this
                            paragraph. You agree that no joint venture,
                            partnership, employment, or agency relationship
                            exists between you and Navajo Nation Department of
                            Personnel Management as a result of this agreement
                            or use of the Navajo Nation Department of Personnel
                            Management Web Site. Navajo Nation Department of
                            Personnel Management&apos;s performance of this
                            agreement is subject to existing laws and legal
                            process, and nothing contained in this agreement is
                            in derogation of Navajo Nation Department of
                            Personnel Management&apos;s right to comply with
                            governmental, court, and law enforcement requests or
                            requirements relating to your use of the Navajo
                            Nation Department of Personnel Management Web Site
                            or information provided to or gathered by Navajo
                            Nation Department of Personnel Management with
                            respect to such use. If any part of this agreement
                            is determined to be invalid or unenforceable
                            pursuant to applicable law including the warranty
                            disclaimers and liability limitations set forth
                            above, then the invalid or unenforceable provision
                            will be deemed superseded by a valid, enforceable
                            provision that most closely matches the intent of
                            the original provision and the remainder of the
                            agreement shall continue in effect. Unless otherwise
                            specified herein, this agreement constitutes the
                            entire agreement between the user and Navajo Nation
                            Department of Personnel Management with respect to
                            the Navajo Nation Department of Personnel Management
                            Web Site, and it supersedes all prior or
                            contemporaneous communications and proposals,
                            whether electronic, oral, or written, between the
                            user and Navajo Nation Department of Personnel
                            Management with respect to the Navajo Nation
                            Department of Personnel Management Web Site. A
                            printed version of this agreement and of any notice
                            given in electronic form shall be admissible in
                            judicial or administrative proceedings based upon or
                            relating to this agreement, to the same extent and
                            subject to the same conditions as other business
                            documents and records originally generated and
                            maintained in printed form. It is the express wish
                            of the parties that this agreement and all related
                            documents be drawn up in English.
                        </div>
                    </Card.Body>
                </Card>
                <Card className="mb-4">
                    <Card.Header as="h2" className="header-card">
                        <span>COPYRIGHT AND TRADEMARK NOTICES: </span>
                    </Card.Header>
                    <Card.Body>
                        <div className="card-text">
                            All contents of the Navajo Nation Department of
                            Personnel Management Web Site are: Copyright 2026 by
                            NNDPM and/or its vendors. All rights reserved.
                        </div>
                    </Card.Body>
                </Card>
                <Card className="mb-4">
                    <Card.Header as="h2" className="header-card">
                        <span>TRADEMARKS </span>
                    </Card.Header>
                    <Card.Body>
                        <div className="card-text">
                            The names of actual companies and products mentioned
                            herein may be the trademarks of their respective
                            owners. The example companies, organizations,
                            products, people and events depicted herein are
                            fictitious. No association with any real company,
                            organization, product, person, or event is intended
                            or should be inferred. Any rights not expressly
                            granted herein are reserved.
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </>
    );
};
